export default function getResource(label) {
    const resources = {
        yourStatus: 'Your status',
        pointsText: 'Your points',
        joinNowBtn: 'Join Now',
        signInBtn: 'Sign In',
        tierProgressLabel: 'Beauty Insider tier progress',
        joinFreeText: 'Join our FREE loyalty & rewards program',
        benefitShipping: '🚚 Get free shipping every time',
        benefitBirthday: '🎂 Choose a birthday gift set',
        benefitPoints: '👛 Earn points on every purchase',
        createAccountBtn: 'Create Account'
    };
    return resources[label];
}
